import { createDustEffect } from "@/presentation/renderers/animations/dustEffect.js";
import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

export function createDuckLineSlotPrefab(k, index, position) {
    const slot = k.add([
        k.rect(50, 50),
        k.pos(position),
        k.anchor("center"),
        k.opacity(0),
        k.area(),
        k.z(80), // Make sure it sits ON TOP of the ducks so it catches the mouse
        ACTOR_TAGS.LINE_SLOT,
        {
            slotIndex: index,
            rock: null,
            opacityTween: null,

            setHighlight(active, color = k.WHITE) {
                const frame = this.get(ACTOR_TAGS.HIGHLIGHT_SLOT)[0];
                if (!frame) return;

                if (this.opacityTween) {
                    this.opacityTween.cancel();
                    this.opacityTween = null;
                }

                if (active) {
                    frame.color = color;
                    frame.opacity = 0;

                    this.opacityTween = k.tween(
                        0,
                        1,
                        0.5,
                        (v) => frame.opacity = v,
                        k.easings.easeOutSine
                    );
                } else {
                    frame.opacity = 0;
                    this.opacityTween = null;
                }
            }
        }
    ]);

    slot.add([
        k.sprite("cursor_playable_card_on_slot", { height: 64, width: 64}),
        k.anchor("center"),
        k.opacity(0),
        k.z(150),
        ACTOR_TAGS.HIGHLIGHT_SLOT
    ]);

    slot.protect = async () => {
        createDustEffect(k, slot);
        slot.rock = slot.add([
            k.sprite("rock3"),
            k.z(85),
            k.opacity(1),
            k.anchor("center"),
            k.pos(0, 5),
            k.scale(1.8),
            ACTOR_TAGS.ROCK_SLOT,
        ])
    }

    slot.expose = async () => {
        createDustEffect(k, slot);
        slot.rock?.destroy();
        slot.rock = null;
    }

    return slot;
}